/** Seven static disclosure PDFs served via API presigned S3 URLs. */
export const DISCLOSURE_DOCUMENTS = [
  { id: 'd1', title: 'Privacy Policy (v1)', envUrl: 'VITE_DISCLOSURE_DOC_1_URL', apiName: 'disclosure_1_privacy_policy_v1' },
  { id: 'd2', title: 'Terms of Use (v1)', envUrl: 'VITE_DISCLOSURE_DOC_2_URL', apiName: 'disclosure_2_terms_of_use_v1' },
  { id: 'd3', title: 'API Integration Guidelines (v1)', envUrl: 'VITE_DISCLOSURE_DOC_3_URL', apiName: 'disclosure_3_api_integration_guidelines_v1' },
  { id: 'd4', title: 'Automated Trading Feature Disclosures (v1)', envUrl: 'VITE_DISCLOSURE_DOC_4_URL', apiName: 'disclosure_4_automated_trading_feature_disclosures_v1' },
  { id: 'd5', title: 'Risk Disclosures (v2)', envUrl: 'VITE_DISCLOSURE_DOC_5_URL', apiName: 'disclosure_5_risk_disclosures_v2' },
  { id: 'd6', title: 'Safety Mechanism Documentation (v1)', envUrl: 'VITE_DISCLOSURE_DOC_6_URL', apiName: 'disclosure_6_safety_mechanism_documentation_v1' },
  { id: 'd7', title: 'User Agreement (v1)', envUrl: 'VITE_DISCLOSURE_DOC_7_URL', apiName: 'disclosure_7_user_agreement_v1' },
];

export function resolveDisclosureApiUrl(doc, apiBaseUrl, env = import.meta.env) {
  return env[doc.envUrl] || `${apiBaseUrl}/agreements/${doc.apiName}`;
}

/**
 * URL used when user clicks View.
 * Default: API ?view=url (JSON presigned S3 link). Env override: direct PDF URL for embed.
 */
export function resolveDisclosureViewUrl(doc, apiBaseUrl, env = import.meta.env) {
  if (env[doc.envUrl]) {
    return env[doc.envUrl];
  }
  return `${apiBaseUrl}/agreements/${doc.apiName}?view=url`;
}

export function disclosureViewNeedsPresignFetch(viewUrl) {
  return (viewUrl || '').includes('view=url');
}

export function buildDisclosureDocumentList(apiBaseUrl, env = import.meta.env) {
  return DISCLOSURE_DOCUMENTS.map((doc) => ({
    ...doc,
    viewUrl: resolveDisclosureViewUrl(doc, apiBaseUrl, env),
  }));
}
